import React, { useState, useEffect } from "react";
import Avatar from "./../Avatar/Avatar";

export const CompanyAvatar = ({ logo, name }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [logo]);

  const isValidLogo =
    logo &&
    typeof logo === "string" &&
    logo.trim() !== "" &&
    logo !== "null" &&
    logo !== "undefined";

  if (isValidLogo && !imgError) {
    return (
      <div
        className="shrink-0 border border-gray-200 rounded-full w-14 h-14 overflow-hidden"
      >
        <Avatar
          size={54}
          shape="circle"
          src={logo}
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
          onError={() => setImgError(true)}
        >
          {name ? name.charAt(0) : "C"}
        </Avatar>
      </div>
    );
  }

  return (
    <div className="w-14 h-14 bg-gray-300 rounded-full flex items-center justify-center text-xl font-bold text-gray-700 uppercase shrink-0 shadow-sm border border-gray-200">
      {name ? name.charAt(0) : ""}
    </div>
  );
};